export const monthsMap = {
  января: 0,
  февраля: 1,
  марта: 2,
  апреля: 3,
  мая: 4,
  июня: 5,
  июля: 6,
  августа: 7,
  сентября: 8,
  октября: 9,
  ноября: 10,
  декабря: 11,
};

export function parseRussianDate(dateStr) {
  const parts = dateStr.split(" ");
  if (parts.length !== 3) return new Date(0);

  const day = parseInt(parts[0], 10);
  const month = monthsMap[parts[1]];
  const year = parseInt(parts[2], 10);

  return new Date(year, month, day);
}

export function sortNewsByDate(news, order = "newest") {
  return [...news].sort((a, b) => {
    const dateA = parseRussianDate(a.date);
    const dateB = parseRussianDate(b.date);
    return order === "newest" ? dateB - dateA : dateA - dateB;
  });
}

export function normalizeNewsItem(item) {
  const images = item.images?.length
    ? item.images
    : item.imagePreview
      ? [item.imagePreview]
      : [];

  return {
    ...item,
    tegs: item.tags || item.tegs || "",
    images,
    image: images,
    imagePreview: item.imagePreview || images[0] || "",
  };
}
